import React from "react";
import ImgOrVideo from "../ImgOrVideo";
import { useParams } from "react-router-dom";
import { getDomainInfo } from "../../utils/utils";
import { FaRegStar, FaStar } from "react-icons/fa";

const ProductCard = ({ product, index, onViewMore, onOpenDrawer, tag, totalProducts }) => {
  const { userId } = useParams();
  const { uid } = getDomainInfo(userId);
  if (!product) return null;

  const StarRating = ({ rating }) => {
    return (
      <div className="star-box">
        {[...Array(5)].map((_, index) =>
          index < rating ? <FaStar key={index} /> : <FaRegStar key={index} />
        )}
      </div>
    );
  };

  const isViewAllCard = index === 4 || (index === totalProducts - 1 && totalProducts < 5);
  return (
    <div
      key={product.id}
      className={`sliderProductCard card ${isViewAllCard ? "view-more-card" : ""}`}
      onClick={isViewAllCard ? onViewMore : undefined}
    >
      <div className="image-container">
      {tag && !isViewAllCard && <span className="label">{tag}</span>}
        <div className={isViewAllCard ? "slider-image":""}>
          <ImgOrVideo
            url={product.images?.[0]}
            uid={uid}
            pid={product.id}
            productName={product.title?.replace(/\s+/g, "_")}
            skuId={product.skuId}
          />
        </div>

        {!isViewAllCard && (
          <div
            className="plus-sign"
            onClick={(e) => {
              e.stopPropagation();
              onOpenDrawer(product);
            }}
          >
            +
          </div>
        )}

        {isViewAllCard && (
          <div className="viewAllSection">
            <span className="view-more-text">View All</span>
            <div className="arrow-circle">→</div>
          </div>
        )}
      </div>

      <p className="product-name fontclass" title={product.title}>
        {product.title?.length > 20 ? product.title.slice(0, 20) + "..." : product.title}
      </p>

      <div className="product-des p-0">
        <div className="star-icons">
          <ul>
            <li><StarRating rating={Math.round(product.avgRating)} /></li>
          </ul>
          <p>({product.totalReviews})</p>
        </div>
      </div>

      <div className="price-section">
        <span className="new-price">
          &#8377;  {(product.price > 0 ? product.price : product.mrp).toLocaleString("en-IN")}
        </span>
        {product.price > 0 && (
          <span className="old-price">
            &#8377; {product.mrp.toLocaleString("en-IN")}
          </span>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
